// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2YIeH","form":"styles_form__29IWh"};